import { useState } from 'react';
import { attendanceService } from 'services/api';
import InfoModal from './InfoModal';
import styles from './ModalidadModal.module.css';

export default function ModalidadModal({ assembly, currentMode, onClose, onSaved }) {
  const [selected, setSelected] = useState(currentMode || null);
  const [saving,   setSaving]   = useState(false);
  const [error,    setError]    = useState('');
  const options = [
    { key: 'virtual', label: 'Virtual',    icon: 'fa-laptop',  desc: 'Participas desde tu dispositivo en línea' },
    { key: 'inplace', label: 'Presencial', icon: 'fa-building', desc: 'Asistes físicamente al lugar de la asamblea' },
  ];
  const save = async () => {
    if (!selected) return;
    setSaving(true); setError('');
    try {
      await attendanceService.setMode(assembly.id, selected);
      onSaved?.(selected);
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'No se pudo guardar.');
    } finally { setSaving(false); }
  };
  return (
    <InfoModal title="Modalidad de participación" icon="fa-rotate" color="#8b5cf6" onClose={onClose}>
      <p className={styles.intro}>
        Indica cómo vas a participar en la asamblea <strong>#{assembly.number_assembly}</strong>.
        Es informativo para la organización.
      </p>
      {error && <div className={`alert alert-danger ${styles.alerta}`}>{error}</div>}
      <div className={styles.opciones}>
        {options.map(opt => (
          <div key={opt.key}
            onClick={() => setSelected(opt.key)}
            className={`${styles.opcion} ${selected === opt.key ? styles.opcionActiva : ''}`}>
            <div className={styles.opcionIcono}>
              <i className={`fas ${opt.icon} ${styles.opcionGlifo}`} />
            </div>
            <div className={styles.opcionTexto}>
              <div className={`${styles.opcionNombre} ${selected === opt.key ? styles.opcionNombreActiva : ''}`}>{opt.label}</div>
              <div className={styles.opcionDescripcion}>{opt.desc}</div>
            </div>
            {selected === opt.key && (
              <i className={`fas fa-circle-check ${styles.opcionCheck}`} />
            )}
          </div>
        ))}
      </div>
      {selected && (
        <button className={`btn btn-primary ${styles.confirmar}`}
          onClick={save} disabled={saving}>
          {saving
            ? <><i className={`fas fa-spinner fa-spin ${styles.icono8}`} />Guardando...</>
            : <><i className={`fas fa-check ${styles.icono8}`} />Confirmar modalidad</>}
        </button>
      )}
    </InfoModal>
  );
}
